
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.3 9.5l3.181 16.8h28.76l1.66-16.8H5.3z","fill":"#FFD250"}}),_c('path',{attrs:{"d":"M.9 11.745h39.2M37.7 11.9l-3.289 17.2H6.864L3.301 11.9M16.331 1.192L6.5 11.714M24.33 1.192l9.832 10.522M12.7 14.7v10M20.7 14.7v10M28.7 14.7v10","stroke":"#231F20"}})])
          )
        }
      }
    